<div class="relative">
  <button
    #trigger
    type="button"
    class="flex size-10 cursor-pointer items-center justify-center rounded-full focus-visible:outline-2"
    aria-haspopup="true"
    aria-controls="user-menu-panel"
    [attr.aria-expanded]="isOpen()"
    [attr.aria-label]="'shell.userMenu.label' | transloco"
    (click)="toggle()"
  >
    <img src="/icons/user-avatar-placeholder.svg" alt="" class="size-7" />
  </button>

  <div
    id="user-menu-panel"
    class="w-menu-panel rounded-panel border-divider shadow-dropdown absolute right-0 z-10 mt-1 origin-top-right border bg-white transition-all duration-150 ease-out"
    [class.pointer-events-none]="!isOpen()"
    [class.invisible]="!isOpen()"
    [class.scale-95]="!isOpen()"
    [class.opacity-0]="!isOpen()"
    [class.scale-100]="isOpen()"
    [class.opacity-100]="isOpen()"
  >
    <div class="border-divider flex flex-col gap-2 border-b px-2 py-4">
      <div class="flex items-center gap-2 p-2">
        <img src="/icons/user-avatar-placeholder.svg" alt="" class="size-6" />
        <span class="text-primary text-button-s font-sans font-semibold">
          {{ accountLabel() ?? ('shell.userMenu.fallbackName' | transloco) }}
        </span>
      </div>

      <div class="flex flex-col gap-2">
        <button
          type="button"
          class="flex w-full cursor-pointer items-center justify-between p-2 focus-visible:outline-2"
          aria-haspopup="true"
          aria-controls="language-switcher-panel"
          [attr.aria-expanded]="isLanguageExpanded()"
          (click)="toggleLanguage()"
        >
          <span class="flex items-center gap-2">
            <img src="/icons/globe.svg" alt="" class="size-6" />
            <span class="text-primary text-button-s font-sans font-semibold">
              {{ 'shell.languageSwitcher.label' | transloco }}
            </span>
          </span>
          <img
            src="/icons/chevron-down.svg"
            alt=""
            class="size-4 transition-transform duration-200 ease-out"
            [class.rotate-180]="isLanguageExpanded()"
          />
        </button>

        @if (isLanguageExpanded()) {
          <ul id="language-switcher-panel" class="flex flex-col">
            @for (lang of languageService.availableLanguages; track lang) {
              <li>
                <button
                  type="button"
                  [attr.aria-pressed]="languageService.activeLanguage() === lang"
                  class="text-button-s flex h-10 w-full cursor-pointer items-center py-1.25 pr-1.25 pl-10 text-left font-sans text-gray-700 focus-visible:outline-2"
                  [class.font-semibold]="languageService.activeLanguage() === lang"
                  (click)="selectLanguage(lang)"
                >
                  {{ 'shell.languageSwitcher.' + lang | transloco }}
                </button>
              </li>
            }
          </ul>
        }
      </div>
    </div>

    <div class="flex flex-col gap-2 px-2 py-4">
      <button
        type="button"
        class="flex w-full cursor-pointer items-center gap-2 p-2 focus-visible:outline-2"
        (click)="logout()"
      >
        <img src="/icons/sign-out.svg" alt="" class="size-6" />
        <span class="text-primary text-button-s font-sans font-semibold">
          {{ 'shell.userMenu.logout' | transloco }}
        </span>
      </button>
    </div>
  </div>
</div>
